import { EntityType } from "../../../../CoStar/Api/AptsNet/MobileServices/ViewModels/Renters/index.js";
/** CoStar.Api.AptsRenters.ViewModels.EntityType */
export { EntityType };
